// Centralized configuration for Lumentec Systems
// This is the single source of truth for company contact details

export const COMPANY_CONFIG = {
  phone: "9831317618",
  phoneFormatted: "+91 9831317618",
  phone2: "9433059510",
  phoneFormatted2: "+91 9433059510",
  email: "inquiry@lumentecsystems.com",
  whatsappNumber: "919831317618",
  whatsappDefaultMessage: "Hello Lumentec Systems, I'm interested in your lighting solutions",
};

// Export individual values for backward compatibility
export const PHONE = COMPANY_CONFIG.phone;
export const PHONE_FORMATTED = COMPANY_CONFIG.phoneFormatted;
export const EMAIL = COMPANY_CONFIG.email;
export const WHATSAPP_NUMBER = COMPANY_CONFIG.whatsappNumber;
export const WHATSAPP_DEFAULT_MESSAGE = COMPANY_CONFIG.whatsappDefaultMessage;
